module.exports = __webpack_public_path__ + "img/download-icon.4ffb6d62.svg";